'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = require('../../../../../events');

var _events2 = _interopRequireDefault(_events);

var _routerHistory = require('../../../../../router-history');

var _routerHistory2 = _interopRequireDefault(_routerHistory);

var _stages = require('../../../../../stages');

var _ifeisIsomorphic = require('ifeis-isomorphic');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdjudicationScoresheetController = function () {
  function AdjudicationScoresheetController($scope, $state, feis, stages, event, $mdSidenav, msgService, fEventService, fRouterHistoryService, $q, $filter, $stateParams) {
    var _this = this;

    _classCallCheck(this, AdjudicationScoresheetController);

    this.feis = feis;
    this.eventService = fEventService.for(this.feis.id);
    this._svc = {
      $state: $state,
      $mdSidenav: $mdSidenav,
      msgService: msgService,
      fRouterHistoryService: fRouterHistoryService,
      $filter: $filter,
      $stateParams: $stateParams
    };
    this.scoresheets = [];
    this.scoresheetsNum = 3;
    this.scoresheetsStart = 0;
    this.round = 1;
    this.sidebarStage = 0;
    this.stages = stages;
    this.event = event;
    this.sidenav = $mdSidenav('stageSwitch');
    this.currentEvent = { participantQueue: [] };

    $scope.$watch(function () {
      return _this.sidebarStage;
    }, function (idx) {
      if (_this.stages) {
        if (_this.stages[idx]) {
          if (!_this.stages[idx].events) {
            _this.stages[idx].schedule().then(function (events) {
              _this.stages[idx].events = _this.cleanPlaceholders(events);
            });
          }
        }
      }
    });

    $scope.$watch(function () {
      return _this.currentEvent.participantQueue;
    }, function () {
      if (_this.currentEvent) {
        _this.calcPlacements();
      }
    }, true);

    $q.when(this.loadStages()).then(function () {
      if ($stateParams.stage) {
        _this.loadStage(_this.getStageIndex($stateParams.stage, _this.stages));
      }
    });
  }

  _createClass(AdjudicationScoresheetController, [{
    key: 'back',
    value: function back() {
      this._svc.fRouterHistoryService.back();
    }
  }, {
    key: 'loadStages',
    value: function loadStages() {
      var _this2 = this;

      this.loading++;
      if (this._svc.$stateParams.stages.length > 1) {
        this.stages = this._svc.$stateParams.stages;
        this.loading--;
      } else {
        return this.stages.all().then(function (s) {
          _this2.stages = s;
          _this2.loading--;
        });
      }
    }
  }, {
    key: 'loadStage',
    value: function loadStage(index) {
      var _this3 = this;

      this.stage = this.stages[index];
      this.sidebarStage = index;
      this.scoresheetVisible = false;
      this.scoresheets = [];
      this.round = 1;
      this.stage.schedule().then(function (events) {
        _this3.stage.events = _this3.cleanPlaceholders(events);
        if (_this3.stage.events.length > 0) {
          _this3.loadEvent(_this3.event);
        } else {
          toast('No events for that stage.');
        }
      });
    }
  }, {
    key: 'loadEvent',
    value: function loadEvent(event) {
      var _this4 = this;

      event.participantQueue = [];
      this.currentEvent = event;

      return this.eventService.participants(event.id).then(function (p) {
        p.forEach(function (i) {
          return i.reg.is_checked_in = i.reg.is_checked_in ? true : false;
        });
        _this4.currentEvent.participants = p;
      }).catch(function () {
        return toast('Error loading participants.');
      });
    }
  }, {
    key: 'addToQueue',
    value: function addToQueue(participant) {
      this.currentEvent.participantQueue.push(participant);
      this.currentEvent.participants.splice(this.currentEvent.participants.indexOf(participant), 1);
    }
  }, {
    key: 'removeFromQueue',
    value: function removeFromQueue(participant) {
      this.currentEvent.participants.push(participant);
      this.currentEvent.participantQueue.splice(this.currentEvent.participantQueue.indexOf(participant), 1);
    }
  }, {
    key: 'closeQueue',
    value: function closeQueue() {
      this.scoresheetVisible = true;
      this.loadScoresheets(this.scoresheetsStart);
    }
  }, {
    key: 'loadScoresheets',
    value: function loadScoresheets(start) {
      if (start < 0) {
        start = 0;
      }
      var end = start + this.scoresheetsNum;
      if (start + this.scoresheetsNum > this.currentEvent.participantQueue.length) {
        end = this.currentEvent.participantQueue.length;
        start = end - this.scoresheetsNum;
      }
      this.scoresheets = this.currentEvent.participantQueue.slice(start, end);
      this.scoresheetsStart = start;
    }
  }, {
    key: 'setRound',
    value: function setRound(round) {
      this.round = round;
    }
  }, {
    key: 'totalScore',
    value: function totalScore(rounds) {
      var score = 0;
      angular.forEach(rounds, function (round) {
        if (round) {
          round = parseInt(round, 10);
          if (!isNaN(round)) {
            score = score + parseInt(round, 10);
          }
        }
      });
      return score;
    }
  }, {
    key: 'goEvent',
    value: function goEvent(stage, event) {
      var params = {
        stage: stage._stage.id,
        event: event.id,
        stages: this.stages
      };
      this._svc.$state.go(this._svc.$state.current.name, params);
    }
  }, {
    key: 'getStageIndex',
    value: function getStageIndex(id, stages) {
      var index = null;
      angular.forEach(stages, function (s, indx) {
        if (s._stage.id === id) {
          index = indx;
        }
      });
      return index;
    }
  }, {
    key: 'cleanPlaceholders',
    value: function cleanPlaceholders(events) {
      var nevents = [];
      for (var i = 0; i < events.length; i++) {
        if (!events[i].$placeholder) {
          nevents.push(events[i]);
        }
      }
      return nevents;
    }
  }, {
    key: 'toast',
    value: function toast(msg) {
      this._svc.msgService.displayErrorMsg(msg);
    }
  }, {
    key: 'toggleSidenav',
    value: function toggleSidenav() {
      this._svc.$mdSidenav('stageSwitch').toggle();
    }
  }, {
    key: 'calcPlacements',
    value: function calcPlacements() {
      var _this5 = this;

      var scoresheets = this._svc.$filter('orderBy')(this.currentEvent.participantQueue, function (scoresheet) {
        return _this5.totalScore(scoresheet.rounds);
      }, true);

      angular.forEach(this.currentEvent.participantQueue, function (scoresheet, index) {
        scoresheet.$placement = scoresheets.indexOf(scoresheet) + 1;
      });
    }
  }, {
    key: 'getEventName',
    value: function getEventName(event) {
      if (event) {
        return (0, _ifeisIsomorphic.getDescription)(event);
      } else if (this.currentEvent) {
        return (0, _ifeisIsomorphic.getDescription)(this.currentEvent);
      }
    }
  }]);

  return AdjudicationScoresheetController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.adjudication.scoresheet', ['ngMaterial', 'ui.router', 'ifeis.router-history', 'ifeis.stages.service', 'ifeis.events']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.adjudication.scoresheet', {
    url: '/stage/:stage/event/:event',
    views: {
      '@': {
        controller: 'AdjudicationScoresheetController',
        controllerAs: 'ctrl',
        template: require('./scoresheet.tpl.html')
      }
    },
    params: {
      stages: []
    },
    resolve: {
      stages: function stages($stateParams, fStages) {
        return fStages.for($stateParams.id);
      },
      event: function event(fEventService, $stateParams) {
        return fEventService.for($stateParams.id).one($stateParams.event);
      }
    }
  });
}).controller('AdjudicationScoresheetController', AdjudicationScoresheetController).directive('drawCanvas', function ($http, msgService, $timeout, $window) {
  return {
    restrict: 'A',
    scope: {
      drawValue: '=',
      scoresheet: '=',
      calc: '='
    },
    link: function link(scope, element) {
      var ctx = element[0].getContext('2d');

      ctx.lineWidth = 4;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.fillStyle = 'blue';
      ctx.strokeStyle = 'black';

      // MyScript API key
      var apiKey = '81bcb62d-a182-4fb0-84c5-8faec6ebf2b0';

      // variable that decides if something should be drawn on mousemove
      var drawing = false;

      var iOS = navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false;

      var strokes = [];
      var stroke;

      // the last coordinates before the current move
      var lastX, lastY, currentX, currentY;

      if (scope.scoresheet) {
        scope.scoresheet.clean = function () {
          reset();
        };
      }

      // prototype to  start drawing on touch using canvas moveTo and lineTo
      var x, y;
      var start = function start(event) {
        if (iOS) {
          lastX = event.layerX;
          lastY = event.layerY;
        } else {
          lastX = event.changedTouches[0].clientX - event.target.offsetParent.offsetLeft;
          lastY = event.changedTouches[0].clientY - event.target.offsetParent.offsetTop - 140;
        }

        stroke = {
          'type': 'stroke',
          'x': [lastX],
          'y': [lastY]
        };

        // begins new line
        ctx.beginPath();

        drawing = true;
      };
      var move = function move(event) {
        if (drawing) {
          // get current touch position

          if (iOS) {
            currentX = event.layerX;
            currentY = event.layerY;
          } else {
            currentX = event.changedTouches[0].clientX - event.target.offsetParent.offsetLeft;
            currentY = event.changedTouches[0].clientY - event.target.offsetParent.offsetTop - 140;
          }

          stroke.x.push(currentX);
          stroke.y.push(currentY);

          draw(lastX, lastY, currentX, currentY);

          // set current coordinates to last one
          lastX = currentX;
          lastY = currentY;
        }
      };
      var end = function end(event) {
        // stop drawing
        drawing = false;
        strokes.push(stroke);
        recognize(strokes, apiKey);
      };
      element.bind('touchstart', start);
      element.bind('touchmove', move);
      element.bind('touchend', end);

      element.bind('mousedown', function (event) {
        if (event.offsetX !== undefined) {
          lastX = event.offsetX;
          lastY = event.offsetY;
        } else {
          lastX = event.layerX - event.currentTarget.offsetLeft;
          lastY = event.layerY - event.currentTarget.offsetTop;
        }

        stroke = {
          'type': 'stroke',
          'x': [lastX],
          'y': [lastY]
        };

        // begins new line
        ctx.beginPath();

        drawing = true;
      });
      element.bind('mousemove', function (event) {
        if (drawing) {
          // get current mouse position
          if (event.offsetX !== undefined) {
            currentX = event.offsetX;
            currentY = event.offsetY;
          } else {
            currentX = event.layerX - event.currentTarget.offsetLeft;
            currentY = event.layerY - event.currentTarget.offsetTop;
          }

          stroke.x.push(currentX);
          stroke.y.push(currentY);

          draw(lastX, lastY, currentX, currentY);

          // set current coordinates to last one
          lastX = currentX;
          lastY = currentY;
        }
      });
      element.bind('mouseup', function (event) {
        // stop drawing
        drawing = false;
        strokes.push(stroke);
        recognize(strokes, apiKey);
        //reset();
      });

      scope.$watch('drawValue', function (val) {
        if (!val) {
          reset();
        }
      });

      // Timeout to allow the directive to initialize
      $timeout(function () {
        sizeCanvas();
      }, 100);

      angular.element($window).bind('resize', function () {
        sizeCanvas();
      });

      function sizeCanvas() {
        element[0].width = element.parent()[0].offsetWidth;
        element[0].height = element.parent()[0].offsetHeight;
      }

      // canvas reset
      function reset() {
        strokes = [];
        element[0].width = element[0].width;
      }

      function draw(lX, lY, cX, cY) {
        // line from
        ctx.moveTo(lX, lY);
        // to
        ctx.lineTo(cX, cY);
        // color
        ctx.strokeStyle = '#4bf';
        // draw it
        ctx.stroke();
      }

      function recognize(strokes, apiKey, url) {
        // send to myscript for recognition
        if (!url) url = 'https://cloud.myscript.com/api/myscript/v2.0/hwr/doSimpleRecognition.json';

        var jsonPost = {
          'hwrParameter': {
            /** Language is a mandatory parameter. */
            'language': 'en_US'
          },
          'inputUnits': [{
            'components': strokes
          }]
        };
        /** Send data to POST. Give your API key as supplied on registration, or the
         * server will not recognize you as a valid user. */
        var data = {
          'apiKey': apiKey,
          'hwrInput': JSON.stringify(jsonPost)
        };

        /** Display the "wait" symbol while processing is underway. */
        $http({
          method: 'POST',
          url: url,
          params: data,
          transformResponse: function transformResponse(data, headersGetter, status) {
            return data;
          }
        }).then(function (result) {
          var data = JSON.parse(result.data);
          //scope.drawValue = result.data;
          var num = data.result.textSegmentResult.candidates[0].label;
          if (num === '.') {
            reset();
            scope.drawValue = "";
          } else {
            scope.drawValue = num;
          }
          //scope.calc();
        }, function (error) {
          reset();
          console.log('error: ', error);
          msgService.displayErrorMsg('MyScript quota exceeded for developer account.');
        });
      }
    }
  };
}).filter('ordinal', function () {
  function teens() {
    return [11, 12, 13, 14, 15, 16, 17, 18, 19];
  }

  function blank(n) {
    return 'string' === typeof n && 0 === n.trim().length;
  }

  function numeric(n) {
    return 'number' === typeof +n && !Number.isNaN(+n);
  }

  function valid(n) {
    return numeric(n) && !blank(n) && 'object' !== (typeof n === 'undefined' ? 'undefined' : _typeof(n));
  }

  function validate(n) {
    if (!valid(n)) {
      throw new Error('Must be a number or numeric string');
    }
  }

  function indicator(n) {
    validate(n);

    var remainder = n % 10;
    if (~teens().indexOf(n)) {
      return 'th';
    }
    var scase;
    switch (n % 10) {
      case 1:
        scase = 'st';
        break;
      case 2:
        scase = 'nd';
        break;
      case 3:
        scase = 'rd';
        break;
      default:
        scase = 'th';
    }
    return scase;
  }

  function english(n) {
    return n + indicator(n);
  }

  return function (input) {
    var num = parseInt(input, 10);
    return isNaN(num) ? input : english(num);
  };
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/adjudication/scoresheet.js
// module id = 537
// module chunks = 0